import "isomorphic-fetch";
// import { devheaders } from '../api';
import { API_BASE_URL } from '../config/api';
import { nodeConstants } from '../_constants';
import { history } from '../_helpers';
import { NodeCacheService } from '../_helpers/nodeCache';
import { fetchWithAuth } from '../_helpers/fetchWithAuth';
import { runCachedRequest } from '../_helpers/requestCache';
// const APIKEY = '8d6lepmgrcjku9l7i1b8m7po9f'
// const API = 'https://dam.celum.net/cora'
const API = API_BASE_URL
// const lang = 'de';
// const headers = {
//   'Accept': 'application/json',
//   'Content-Type': 'application/json',
//   'Authorization': `celumApiKey ${APIKEY}`
// }


// export const NODES_HAS_ERRORED = 'NODES_HAS_ERRORED';
// export const NODES_IS_LOADING = 'NODES_IS_LOADING';
// export const NODES_FETCH_DATA_SUCCESS = 'NODES_FETCH_DATA_SUCCESS';


function nodesHasErrored(bool) {
  return {
    type: nodeConstants.NODE_HAS_ERRORED,
    hasErrored: bool
  };
}

function nodesSetRoot(rootId) {
  return {
    type: nodeConstants.NODE_SET_ROOT,
    rootId
  };
}

function nodesFetchDataSuccess(nodes, id) {
  return {
    type: nodeConstants.NODE_FETCH_DATA_SUCCESS,
    nodes,
    id
  };
}

export function setRootId(id) {
  return (dispatch) => {
    dispatch(nodesSetRoot(id));
    return id;
  }
}

/**
 * Load all nodes and cache them
 * Should be called once on app initialization
 */
export function nodesLoadAll() {
  return async (dispatch) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',  
      'Authorization': `Bearer ${user.token}`
    }
    
    try {
      // Check cache first
      const cached = NodeCacheService.getFromCache();
      
      if (cached && cached.nodes && !NodeCacheService.isCacheExpired()) {
        // Validate with hash
        try {
          const hashResponse = await fetch(API + '/nodes/hash', {
            method: 'GET',
            headers
          });
          
          if (hashResponse.ok) {
            const hashData = await hashResponse.json();
            
            if (NodeCacheService.isCacheValid(hashData.hash)) {
              return cached.nodes;
            } else {
              }
          }
        } catch (hashError) {
          console.warn('⚠️ Hash check failed, using cache:', hashError);
          return cached.nodes;
        }
      }
      
      // Fetch all nodes from API
      const response = await fetch(API + '/nodes?page=1&pageSize=10000&includeAssets=false&includeMetadata=false&includeFiles=false', {
        method: 'GET',
        headers
      });
      
      if (!response.ok) {
        if (response.status === 403) {
          history.push('/login');
        }
        throw Error(response.statusText);
      }
      
      const data = await response.json();
      const allNodes = data.entities || [];
      
      // Calculate hash and save to cache
      const hash = NodeCacheService.calculateHash(allNodes);
      NodeCacheService.saveToCache(allNodes, hash);
      
      return allNodes;
      
    } catch (error) {
      console.error('Failed to load all nodes:', error);
      
      // Try to use stale cache as fallback
      const cached = NodeCacheService.getFromCache();
      if (cached && cached.nodes) {
        console.warn('⚠️ Using stale cache due to fetch error');
        return cached.nodes;
      }
      
      throw error;
    }
  };
}

export function nodesFetchData(id) {
  return async (dispatch) => {
    try {
      // Use the same cache key/URL as assetsFetchData so concurrent calls
      // (click handler + componentDidMount) share a single in-flight request.
      const response = await runCachedRequest(
        `node-assets:${id}:files=true`,
        () => fetchWithAuth(API + `/nodes/${id}?includeAssets=true&includeFiles=true`, {
          method: 'GET',
        }),
        { ttl: 30 * 1000 },
      );

      if (!response.ok) {
        if (response.status === 403) {
          history.push('/login');
        }
        throw Error(response.statusText);
      }

      const nodes = await response.json();

      dispatch(nodesFetchDataSuccess(nodes, id));
      return nodes;

    } catch (error) {
      console.error('Failed to fetch nodes:', error);
      dispatch(nodesHasErrored(true));
      throw error;
    }
  };
}

/**
 * Fetch multiple nodes in a single batch request.
 * Replaces N individual nodesFetchData calls (N+1 pattern) with one request.
 */
export function nodesFetchBatch(ids) {
  return async (dispatch) => {
    if (!ids || ids.length === 0) return [];
    try {
      const idsParam = ids.join(',');
      const response = await runCachedRequest(
        `nodes-batch:${idsParam}`,
        () => fetchWithAuth(`${API}/nodes/batch?ids=${idsParam}`, { method: 'GET' }),
      );

      if (!response.ok) {
        if (response.status === 403) {
          history.push('/login');
        }
        throw Error(response.statusText);
      }

      const nodes = await response.json();
      nodes.forEach((node) => {
        if (node && node.id) {
          dispatch(nodesFetchDataSuccess(node, node.id));
        }
      });
      return nodes;
    } catch (error) {
      console.error('Failed to batch-fetch nodes:', error);
      dispatch(nodesHasErrored(true));
      throw error;
    }
  };
}
